/* eslint-disable no-template-curly-in-string */
import React, {useState, useMemo} from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  InputGroup,
  Badge,
  Modal,
  Alert,
  Tabs,
  Tab,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import {
  FaFileAlt,
  FaPlus,
  FaSearch,
  FaFilter,
  FaEdit,
  FaTrash,
  FaCopy,
  FaEye,
  FaWhatsapp,
  FaSms,
  FaPoll,
  FaClock,
  FaGift,
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
  FaDownload,
  FaUpload,
  FaTags,
  FaImage,
} from "react-icons/fa";
import {FaEnvelope} from "react-icons/fa";
import {ButtonGroup} from "react-bootstrap";

// Datos simulados de plantillas
const templatesData = [
  {
    id: 1,
    name: "Bienvenida Nuevo Empleado",
    description: "Plantilla para dar la bienvenida a nuevos empleados",
    category: "Bienvenida",
    channel: "whatsapp",
    content:
      "¡Hola {{firstName}}! 👋\n\nBienvenido/a a {{company}}. Estamos emocionados de tenerte en nuestro equipo.\n\nEn los próximos días recibirás más información sobre tu proceso de inducción.\n\n¡Esperamos trabajar contigo!",
    variables: ["firstName", "company"],
    hasMedia: false,
    hasPoll: false,
    hasIncentive: false,
    rating: 4.8,
    usageCount: 156,
    createdAt: "2023-10-15",
    tags: ["bienvenida", "empleados", "inducción"],
    isPublic: true,
    author: "Sistema",
  },
  {
    id: 2,
    name: "Encuesta Satisfacción Almuerzo",
    description: "Plantilla para encuesta sobre preferencias de almuerzo",
    category: "Encuestas",
    channel: "whatsapp",
    content:
      "Hola {{firstName}} 🍽️\n\nNos gustaría conocer tu opinión sobre nuestro servicio de almuerzo para mejorarlo.\n\n¿Podrías ayudarnos respondiendo esta breve encuesta?",
    variables: ["firstName"],
    hasMedia: false,
    hasPoll: true,
    hasIncentive: false,
    rating: 4.5,
    usageCount: 89,
    createdAt: "2023-11-02",
    tags: ["encuesta", "almuerzo", "satisfacción"],
    isPublic: true,
    author: "Sistema",
  },
  {
    id: 3,
    name: "Promoción con Descuento",
    description: "Plantilla para promociones con código de descuento",
    category: "Promociones",
    channel: "whatsapp",
    content:
      "🎉 ¡Oferta Especial para {{firstName}}!\n\nDisfruta de un {{discount}}% de descuento en {{product}}.\n\nUsa el código: {{promoCode}}\n\nVálido hasta {{endDate}}",
    variables: ["firstName", "discount", "product", "promoCode", "endDate"],
    hasMedia: true,
    hasPoll: false,
    hasIncentive: true,
    rating: 4.9,
    usageCount: 234,
    createdAt: "2023-09-20",
    tags: ["promoción", "descuento", "ventas"],
    isPublic: true,
    author: "Sistema",
  },
  {
    id: 4,
    name: "Recordatorio de Evento",
    description: "Plantilla para recordar eventos próximos",
    category: "Eventos",
    channel: "whatsapp",
    content:
      "📅 Recordatorio: {{eventName}}\n\nHola {{firstName}}, te recordamos que el evento {{eventName}} será el {{eventDate}} a las {{eventTime}}.\n\n📍 Lugar: {{location}}\n\n¡Te esperamos!",
    variables: ["firstName", "eventName", "eventDate", "eventTime", "location"],
    hasMedia: false,
    hasPoll: false,
    hasIncentive: false,
    rating: 4.6,
    usageCount: 67,
    createdAt: "2023-11-10",
    tags: ["evento", "recordatorio", "cita"],
    isPublic: true,
    author: "Sistema",
  },
  {
    id: 5,
    name: "Actualización de Seguridad",
    description: "Plantilla para comunicar actualizaciones de seguridad",
    category: "Seguridad",
    channel: "email",
    content:
      "Estimado/a {{firstName}},\n\nTe informamos sobre una importante actualización de seguridad en nuestros sistemas.\n\nPor favor, actualiza tu contraseña siguiendo este enlace: {{updateLink}}\n\nGracias por tu colaboración.",
    variables: ["firstName", "updateLink"],
    hasMedia: false,
    hasPoll: false,
    hasIncentive: false,
    rating: 4.2,
    usageCount: 45,
    createdAt: "2023-10-30",
    tags: ["seguridad", "actualización", "contraseña"],
    isPublic: true,
    author: "Sistema",
  },
  {
    id: 6,
    name: "Confirmación de Pedido",
    description: "Plantilla para confirmar pedidos realizados",
    category: "Confirmaciones",
    channel: "sms",
    content:
      "Pedido #{{orderNumber}} confirmado.\nTotal: ${{total}}\nEntrega: {{deliveryDate}}\nSeguimiento: {{trackingLink}}",
    variables: ["orderNumber", "total", "deliveryDate", "trackingLink"],
    hasMedia: false,
    hasPoll: false,
    hasIncentive: false,
    rating: 4.7,
    usageCount: 178,
    createdAt: "2023-11-05",
    tags: ["pedido", "confirmación", "entrega"],
    isPublic: true,
    author: "Sistema",
  },
];

const Templates = () => {
  const [templates, setTemplates] = useState(templatesData);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedChannel, setSelectedChannel] = useState("all");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [activeTab, setActiveTab] = useState("all");

  // Componente para las tarjetas de KPIs
  const KpiCard = ({icon, title, value, color}) => (
    <Card
      className={`shadow-sm rounded-4 border-0 border-start border-5 border-${color} h-100`}
    >
      <Card.Body className="d-flex align-items-center">
        <div className={`fs-2 text-${color} me-3`}>{icon}</div>
        <div>
          <div className="fs-4 fw-bold">{value}</div>
          <div className="text-muted text-uppercase small">{title}</div>
        </div>
      </Card.Body>
    </Card>
  );

  // Obtener categorías únicas
  const categories = useMemo(() => {
    const cats = [...new Set(templates.map((t) => t.category))];
    return cats.sort();
  }, [templates]);

  // Filtrar plantillas
  const filteredTemplates = useMemo(() => {
    let filtered = templates;

    // Filtro por tab activo
    if (activeTab === "favorites") {
      filtered = filtered.filter((t) => t.rating >= 4.5);
    } else if (activeTab === "recent") {
      filtered = filtered
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .slice(0, 10);
    } else if (activeTab === "popular") {
      filtered = filtered
        .sort((a, b) => b.usageCount - a.usageCount)
        .slice(0, 10);
    }

    // Filtro por búsqueda
    if (searchTerm) {
      filtered = filtered.filter(
        (t) =>
          t.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.tags.some((tag) =>
            tag.toLowerCase().includes(searchTerm.toLowerCase())
          )
      );
    }

    // Filtro por categoría
    if (selectedCategory !== "all") {
      filtered = filtered.filter((t) => t.category === selectedCategory);
    }

    // Filtro por canal
    if (selectedChannel !== "all") {
      filtered = filtered.filter((t) => t.channel === selectedChannel);
    }

    return filtered;
  }, [templates, searchTerm, selectedCategory, selectedChannel, activeTab]);

  // Métricas
  const metrics = useMemo(() => {
    const total = templates.length;
    const whatsapp = templates.filter((t) => t.channel === "whatsapp").length;
    const email = templates.filter((t) => t.channel === "email").length;
    const sms = templates.filter((t) => t.channel === "sms").length;
    const avgRating = (
      templates.reduce((sum, t) => sum + t.rating, 0) / total
    ).toFixed(1);

    return {total, whatsapp, email, sms, avgRating};
  }, [templates]);

  // Función para obtener icono del canal
  const getChannelIcon = (channel) => {
    switch (channel) {
      case "whatsapp":
        return <FaWhatsapp className="text-success" />;
      case "email":
        return <FaEnvelope className="text-primary" />;
      case "sms":
        return <FaSms className="text-warning" />;
      default:
        return <FaFileAlt />;
    }
  };

  // Función para obtener badge del canal
  const getChannelBadge = (channel) => {
    const configs = {
      whatsapp: {bg: "success", text: "WhatsApp"},
      email: {bg: "primary", text: "Email"},
      sms: {bg: "warning", text: "SMS"},
    };
    const config = configs[channel] || {bg: "secondary", text: channel};
    return <Badge bg={config.bg}>{config.text}</Badge>;
  };

  // Función para renderizar estrellas de rating
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={i} className="text-warning" />);
    }
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" className="text-warning" />);
    }
    for (let i = stars.length; i < 5; i++) {
      stars.push(<FaRegStar key={i} className="text-muted" />);
    }
    return stars;
  };

  // Función para previsualizar plantilla
  const previewTemplate = (template) => {
    setSelectedTemplate(template);
    setShowPreviewModal(true);
  };

  // Función para duplicar plantilla
  const duplicateTemplate = (template) => {
    const newTemplate = {
      ...template,
      id: Date.now(),
      name: template.name + " (Copia)",
      usageCount: 0,
      createdAt: new Date().toISOString().split("T")[0],
      author: "Usuario",
    };
    setTemplates([...templates, newTemplate]);
  };

  return (
    <Container fluid className="p-4 bg-light">
      {/* Header */}
      <Row className="align-items-center mb-4">
        <Col>
          <h2 className="fw-bold mb-0">
            <FaFileAlt className="me-3 text-primary" />
            Biblioteca de Plantillas
          </h2>
          <p className="text-muted mb-0">
            Gestiona y reutiliza plantillas para tus comunicaciones
          </p>
        </Col>
        <Col xs="auto">
          <Dropdown as={ButtonGroup}>
            <Button
              variant="primary"
              size="lg"
              onClick={() => setShowCreateModal(true)}
              className="rounded-start-pill px-4"
            >
              <FaPlus className="me-2" />
              Nueva Plantilla
            </Button>
            <Dropdown.Toggle
              split
              variant="primary"
              size="lg"
              className="rounded-end-pill"
            />
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => {}}>
                <FaUpload className="me-2" /> Importar Plantillas
              </Dropdown.Item>
              <Dropdown.Item onClick={() => {}}>
                <FaDownload className="me-2" /> Exportar Plantillas
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>

      {/* KPIs */}
      <Row className="mb-4">
        <Col md={3}>
          <KpiCard
            icon={<FaFileAlt />}
            title="Total Plantillas"
            value={metrics.total}
            color="primary"
          />
        </Col>
        <Col md={3}>
          <KpiCard
            icon={<FaWhatsapp />}
            title="WhatsApp"
            value={metrics.whatsapp}
            color="success"
          />
        </Col>
        <Col md={3}>
          <KpiCard
            icon={<FaEnvelope />}
            title="Email"
            value={metrics.email}
            color="info"
          />
        </Col>
        <Col md={3}>
          <KpiCard
            icon={<FaStar />}
            title="Rating Promedio"
            value={metrics.avgRating}
            color="warning"
          />
        </Col>
      </Row>

      {/* Filtros */}
      <Card className="shadow-sm rounded-4 border-0 mb-4">
        <Card.Body className="p-3">
          <Row className="align-items-center">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Buscar plantillas..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
            </Col>
            <Col md={3}>
              <DropdownButton
                variant="outline-secondary"
                title={
                  <>
                    <FaFilter className="me-2" />
                    Categoría
                  </>
                }
                onSelect={(value) => setSelectedCategory(value)}
              >
                <Dropdown.Item eventKey="all">
                  Todas las categorías
                </Dropdown.Item>
                <Dropdown.Divider />
                {categories.map((cat) => (
                  <Dropdown.Item key={cat} eventKey={cat}>
                    {cat}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </Col>
            <Col md={3}>
              <DropdownButton
                variant="outline-secondary"
                title="Canal"
                onSelect={(value) => setSelectedChannel(value)}
              >
                <Dropdown.Item eventKey="all">Todos los canales</Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item eventKey="whatsapp">
                  <FaWhatsapp className="me-2 text-success" />
                  WhatsApp
                </Dropdown.Item>
                <Dropdown.Item eventKey="email">
                  <FaEnvelope className="me-2 text-primary" />
                  Email
                </Dropdown.Item>
                <Dropdown.Item eventKey="sms">
                  <FaSms className="me-2 text-warning" />
                  SMS
                </Dropdown.Item>
              </DropdownButton>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Tabs de navegación */}
      <Card className="shadow-sm rounded-4 border-0">
        <Card.Header className="bg-white border-bottom-0">
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="border-0"
          >
            <Tab
              eventKey="all"
              title={
                <span>
                  <FaFileAlt className="me-2" />
                  Todas ({templates.length})
                </span>
              }
            />
            <Tab
              eventKey="favorites"
              title={
                <span>
                  <FaStar className="me-2" />
                  Destacadas ({templates.filter((t) => t.rating >= 4.5).length})
                </span>
              }
            />
            <Tab
              eventKey="recent"
              title={
                <span>
                  <FaClock className="me-2" />
                  Recientes
                </span>
              }
            />
            <Tab
              eventKey="popular"
              title={
                <span>
                  <FaEye className="me-2" />
                  Populares
                </span>
              }
            />
          </Tabs>
        </Card.Header>

        <Card.Body className="p-4">
          {filteredTemplates.length === 0 ? (
            <div className="text-center p-5">
              <FaFileAlt className="fs-1 text-muted mb-3" />
              <h5 className="text-muted">No se encontraron plantillas</h5>
              <p className="text-muted">
                Ajusta los filtros o crea una nueva plantilla
              </p>
              <Button
                variant="primary"
                onClick={() => setShowCreateModal(true)}
              >
                <FaPlus className="me-2" />
                Crear Primera Plantilla
              </Button>
            </div>
          ) : (
            <Row>
              {filteredTemplates.map((template) => (
                <Col lg={4} md={6} key={template.id} className="mb-4">
                  <Card className="h-100 shadow-sm border-0 rounded-3">
                    <Card.Header className="bg-light border-0 d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        {getChannelIcon(template.channel)}
                        <span className="ms-2 fw-bold">
                          {template.category}
                        </span>
                      </div>
                      {getChannelBadge(template.channel)}
                    </Card.Header>

                    <Card.Body className="d-flex flex-column">
                      <div className="mb-3">
                        <h6 className="fw-bold mb-2">{template.name}</h6>
                        <p className="text-muted small mb-2">
                          {template.description}
                        </p>

                        {/* Rating y uso */}
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <div className="d-flex align-items-center">
                            {renderStars(template.rating)}
                            <span className="ms-2 small text-muted">
                              ({template.rating})
                            </span>
                          </div>
                          <small className="text-muted">
                            {template.usageCount} usos
                          </small>
                        </div>

                        {/* Características */}
                        <div className="d-flex gap-1 mb-3">
                          {template.hasMedia && (
                            <Badge bg="info" className="small">
                              <FaImage className="me-1" />
                              Media
                            </Badge>
                          )}
                          {template.hasPoll && (
                            <Badge bg="success" className="small">
                              <FaPoll className="me-1" />
                              Encuesta
                            </Badge>
                          )}
                          {template.hasIncentive && (
                            <Badge bg="warning" className="small">
                              <FaGift className="me-1" />
                              Incentivo
                            </Badge>
                          )}
                          {template.variables.length > 0 && (
                            <Badge bg="secondary" className="small">
                              {template.variables.length} variables
                            </Badge>
                          )}
                        </div>

                        {/* Tags */}
                        <div className="mb-3">
                          {template.tags.slice(0, 3).map((tag) => (
                            <Badge
                              key={tag}
                              bg="light"
                              text="dark"
                              className="me-1 small"
                            >
                              <FaTags className="me-1" />
                              {tag}
                            </Badge>
                          ))}
                        </div>
                      </div>

                      {/* Acciones */}
                      <div className="mt-auto">
                        <div className="d-flex gap-2">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => previewTemplate(template)}
                            title="Vista previa"
                          >
                            <FaEye />
                          </Button>
                          <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => duplicateTemplate(template)}
                            title="Duplicar"
                          >
                            <FaCopy />
                          </Button>
                          <Button
                            variant="outline-warning"
                            size="sm"
                            title="Editar"
                          >
                            <FaEdit />
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            title="Eliminar"
                          >
                            <FaTrash />
                          </Button>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </Card.Body>
      </Card>

      {/* Modal de Vista Previa */}
      <Modal
        show={showPreviewModal}
        onHide={() => setShowPreviewModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaEye className="me-2 text-primary" />
            Vista Previa: {selectedTemplate?.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedTemplate && (
            <div>
              <Alert variant="info">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <strong>Información de la Plantilla</strong>
                  {getChannelBadge(selectedTemplate.channel)}
                </div>
                <p>
                  <strong>Categoría:</strong> {selectedTemplate.category}
                </p>
                <p>
                  <strong>Variables:</strong>{" "}
                  {selectedTemplate.variables.join(", ") || "Ninguna"}
                </p>
                <p className="mb-0">
                  <strong>Autor:</strong> {selectedTemplate.author}
                </p>
              </Alert>

              <Card className="bg-light">
                <Card.Header>
                  <strong>Contenido de la Plantilla</strong>
                </Card.Header>
                <Card.Body>
                  <pre
                    className="mb-0"
                    style={{whiteSpace: "pre-wrap", fontFamily: "inherit"}}
                  >
                    {selectedTemplate.content}
                  </pre>
                </Card.Body>
              </Card>

              {selectedTemplate.tags.length > 0 && (
                <div className="mt-3">
                  <strong>Etiquetas:</strong>
                  <div className="mt-2">
                    {selectedTemplate.tags.map((tag) => (
                      <Badge key={tag} bg="secondary" className="me-2">
                        <FaTags className="me-1" />
                        {tag}
                      </Badge>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowPreviewModal(false)}
          >
            Cerrar
          </Button>
          <Button
            variant="success"
            onClick={() => duplicateTemplate(selectedTemplate)}
          >
            <FaCopy className="me-2" />
            Usar Plantilla
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de Crear Plantilla */}
      <Modal
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaPlus className="me-2 text-primary" />
            Nueva Plantilla
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="info">
            <strong>Próximamente:</strong> Editor completo de plantillas con
            variables dinámicas, vista previa en tiempo real y soporte para
            múltiples canales.
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
            Cerrar
          </Button>
          <Button variant="primary" disabled>
            Crear Plantilla
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Templates;
